/**
 * Endpoints are switchable per environment (defaults = production):
 *   REACT_APP_GEOSERVER_URL  e.g. "/geoserver"  (dev proxy) or a full URL
 *   REACT_APP_BACKEND_URL    e.g. "/api/v1"     (dev proxy) or a full URL
 * Local values live in .env.development.local (read by `npm start` only, never
 * by `npm run build`); src/setupProxy.js forwards them to the local services.
 */
const GEOSERVER_BASE = (
  process.env.REACT_APP_GEOSERVER_URL ||
  "https://gis.haryanacitygas.com/geoserver"
).replace(/\/$/, "");

/**
 * FastAPI backend (auth + users CRUD).
 * Default "" uses same origin / CRA dev proxy (package.json → localhost:8000).
 * Set REACT_APP_BACKEND_URL for a separate API host in production.
 */
export const BACKEND_API_BASE = (
  process.env.REACT_APP_BACKEND_URL || "https://gis.haryanacitygas.com/api/v1"
).replace(/\/$/, "");

/** Dashboard REST API base */
export const API_BASE = `${BACKEND_API_BASE}/dashboard`;

export const GS_WMS = `${GEOSERVER_BASE}/wms`;
export const GS_WFS = `${GEOSERVER_BASE}/wfs`;

export const GEOSERVER_CONFIG = {
  baseUrl: GEOSERVER_BASE,
  get wfsUrl() {
    return `${this.baseUrl}/wfs`;
  },
  get wmsUrl() {
    return `${this.baseUrl}/wms`;
  },
  getWfsUrlForLayer(wmsUrl) {
    if (wmsUrl) return wmsUrl.replace("/wms", "/wfs");
    return this.wfsUrl;
  },
};

export const DEFAULT_WFS_PARAMS = {
  service: "WFS",
  version: "1.0.0",
  request: "GetFeature",
  outputFormat: "application/json",
  srsName: "EPSG:4326",
};

export const WFS_BASE = DEFAULT_WFS_PARAMS;

/**
 * Directions tool — OSRM routing + OSM Nominatim geocoding.
 * Public demo endpoints; self-host karke yahan URL badal do (production ke liye
 * recommended — dono public services ki fair-use limits hain).
 * NOTE: router.project-osrm.org sirf CAR profile serve karta hai — walking/
 * cycling maangne par bhi wahi car route deta hai. Isliye UI mein mode selector
 * nahi hai; self-hosted OSRM par profile yahan se badal sakte ho.
 */
export const ROUTING_CONFIG = {
  osrmUrl: "https://router.project-osrm.org",
  osrmProfile: "driving",
  nominatimUrl: "https://nominatim.openstreetmap.org",
};
